import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { main_paige_title } from "../../constants/constants";

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>{main_paige_title} - Allgemeine Geschäftsbedingungen </title>
      </Helmet>
      <Header />
      <main id="content">
        <section className="pt-12 pb-10">
          <div className="container">
            <h2 className="fs-sm-40 mb-3 text-center">Allgemeine Geschäftsbedingungen</h2>
          </div>
        </section>
        <div className="pb-7">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-md-12 mb-8 mb-md-0">
                <p>
                  <ul>
                    <li>
                      <a href="#geltungsbereich"> 1. Geltungsbereich</a>
                    </li>
                    <li>
                      <a href="#vertragspartner"> 2. Vertragspartner</a>
                    </li>
                    <li>
                      <a href="#vertragsschluss"> 3. Vertragsschluss</a>
                    </li>
                    <li>
                      <a href="#widerrufsrecht"> 4. Widerrufsrecht</a>
                    </li>
                    <li>
                      <a href="#prise-unde-versandkosten"> 5. Preise und Versandkosten</a>
                    </li>
                    <li>
                      <a href="#lieferung"> 6. Lieferung</a>
                    </li>
                    <li>
                      <a href="#zahlung"> 7. Zahlung</a>
                    </li>
                    <li>
                      <a href="#eigentumsvorbehalt"> 8. Eigentumsvorbehalt</a>
                    </li>
                    <li>
                      <a href="#alternative-streitbeilegung"> 9. Alternative Streitbeilegung</a>
                    </li>
                  </ul>
                </p>
                <p id="geltungsbereich">
                  <h3>1. Geltungsbereich </h3>
                  Für alle Lieferungen von www.Luminit.de an Verbraucher gelten diese Allgemeinen Geschäftsbedingungen (AGB). Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu einem Zwecke abschließt, der überwiegend weder ihrer
                  gewerblichen noch ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden kann.
                  <br />
                </p>
                <p id="vertragspartner">
                  <h3>2. Vertragspartner</h3>
                  Der Kaufvertrag kommt zustande mit Luminit Inhaber: Besar Qelaj, Denhardstr. 24, 41189 Mönchengladbach.
                  <br />
                </p>
                <p id="vertragsschluss">
                  <h3> 3. Vertragsschluss </h3>
                  <b>3.1.</b> Die Darstellung der Produkte im Online-Shop stellt kein rechtlich bindendes Angebot, sondern nur eine Aufforderung zur Bestellung dar.
                  <br />
                  <b>3.2.</b> Durch Anklicken des Buttons [Kaufen/kostenpflichtig bestellen] geben Sie eine verbindliche Bestellung der auf der Bestellseite aufgelisteten Waren ab. Ihr Kaufvertrag kommt zustande, wenn wir Ihre Bestellung durch eine
                  Auftragsbestätigung per E-Mail unmittelbar nach dem Erhalt Ihrer Bestellung annehmen.
                  <br />
                </p>
                <p id="widerrufsrecht">
                  <h3> 4. Widerrufsrecht </h3>
                  <b>4.1.</b> Wenn Sie Verbraucher sind (also eine natürliche Person, die die Bestellung zu einem Zweck abgibt, der weder Ihrer gewerblichen oder selbständigen beruflichen Tätigkeit zugerechnet werden kann), steht Ihnen nach Maßgabe
                  der gesetzlichen Bestimmungen ein Widerrufsrecht zu.
                  <br />
                  <b> 4.2.</b> Machen Sie als Verbraucher von Ihrem Widerrufsrecht nach Ziffer 4.1 Gebrauch, so haben Sie die regelmäßigen Kosten der Rücksendung zu tragen und die Versandkosten werden nicht zurückerstattet.
                  <br />
                  <b> 4.3. </b> Im Übrigen gelten für das Widerrufsrecht die Regelungen, die im Einzelnen wiedergegeben sind in der folgenden
                  <br />
                  <br />
                  <h5>
                    Widerrufsbelehrung <sup>1</sup>
                  </h5>
                  <br />
                  <h5> Widerrufsrecht </h5>
                  <br />
                  <p> Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.</p>
                  <p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen haben bzw. hat.</p>
                  <p>
                    Um Ihr Widerrufsrecht auszuüben, müssen Sie uns Luminit – Besar Qelaj, Denhardstr. 24, 41189 Mönchengladbach +491716181197 E-Mail info@luminit.de mittels einer eindeutigen Erklärung (zB ein mit der Post versandter Brief oder eine
                    E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist. Sie können das Muster-Widerrufsformular oder eine
                    andere eindeutige Erklärung auch auf unserer Webseite www.luminit.de elektronisch ausfüllen und übermitteln. Machen Sie von dieser Möglichkeit Gebrauch, so werden wir Ihnen unverzüglich (zB per E-Mail) eine Bestätigung über den
                    Eingang eines solchen Widerrufs übermitteln.
                  </p>
                  <p> Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden. </p>
                  <br />
                  <br />
                  <h5> Folgen des Widerrufs </h5>
                  <p>
                    Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der
                    Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns
                    eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden
                    Ihnen wegen dieser Rückzahlung Entgelte berechnet. Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zurückgesandt haben, je nachdem,
                    welches der frühere Zeitpunkt ist.
                  </p>
                  <p>
                    Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrages unterrichten, an uns zurückzusenden oder zu übergeben. Die Frist ist gewahrt, wenn
                    Sie die Waren vor Ablauf der Frist von vierzehn Tagen absenden.
                  </p>
                  <p>Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.</p>
                  <b> 4.4. </b> Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen
                  ist. dieser
                  <br />
                </p>
                <p id="prise-und-versandkosten">
                  <h3> 5. Preise und Versandkosten </h3>
                  <b> 5.1. </b> Die auf den Produktseiten genannten Preise enthalten die gesetzliche Mehrwertsteuer und sonstige Preisbestandteile.
                  <br />
                  <b>5.2.</b> Die Versandkosten werden von Luminit.de übernommen.
                </p>
                <p id="lieferung">
                  <h3> 6. Lieferung </h3>
                  <b> 6.1.</b> Die Lieferung erfolgt innerhalb Deutschlands mit DHL.
                  <br />
                  <b> 6.2.</b> Soweit in der Artikelbeschreibung keine andere Frist angegeben ist, erfolgt die Lieferung der Ware in Deutschland innerhalb von 3 bis 5 Tagen nach Auftragsbestätigung (bei vereinbarter Vorauszahlung nach dem Zeitpunkt
                  Ihrer Zahlungsanweisung). Beachten Sie, dass an Sonnund Feiertagen keine Zustellung erfolgt. Auf eventuell abweichende Lieferzeiten weisen wir auf der jeweiligen Produktseite hin.
                </p>
                <p id="zahlung">
                  <h3> 7. Zahlung </h3>
                  <b> 7.1. </b> Die Zahlung erfolgt wahlweise per Vorkasse.
                  <br />
                  <b> 7.2. </b> Bei Auswahl der Zahlungsart Vorkasse bieten wir Ihnen verschiedene Zahlungsoptionen und Zahlungsanbieter an und liefern die Ware nach Zahlungseingang.
                </p>
                <p id="eigentumsvorbehalt">
                  <h3> 8. Eigentumsvorbehalt</h3>
                  Bis zur vollständigen Zahlung bleibt die Ware unser Eigentum.
                </p>
                <p id="alternative-streitbeilegung">
                  <h3> 9. Alternative Streitbeilegung</h3>
                  Streitbeilegung Die EU-Kommission hat eine Internetplattform zur Online-Beilegung von Streitigkeiten geschaffen. Die Plattform dient als Anlaufstelle zur außergerichtlichen Beilegung von Streitigkeiten betreffend vertragliche
                  Verpflichtungen, die aus Online-Kaufverträgen erwachsen. Nähere Informationen sind unter dem folgenden Link verfügbar: http://ec.europa.eu/consumers/odr. Zur Teilnahme an einem Streitbeilegungsverfahren vor einer
                  Verbraucherschlichtungsstelle sind wir weder bereit noch verpflichtet.
                </p>
                <sub>* 1. Diese Widerrufsbelehrung gilt ab 28.05.2022. Sie gilt nicht für die getrennte Lieferung von Waren. Hier für gibt es ein eigenes Muster www.ihk-muenchen.de/mustervertraege/.</sub>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsConditions;
